var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vggrid',{attrs:{"random":Math.floor(Math.random() * 999999),"list":_vm.list,"flexname":"","cols":_vm.pexCols,"showfooter":false,"showPage":false,"resizable":true}},[_c('template',{slot:"btn"},[_c('el-button',{staticClass:"vxe-btn",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.toChangePoints}},[_vm._v("申请")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }